export const changePassword = {
    title: 'เปลี่ยนรหัสผ่าน',
    CurrentPassword: {
        name: 'รหัสผ่านปัจจุบัน',
        placeholder: 'รหัสผ่านปัจจุบัน',
        required: 'โปรดระบุรหัสผ่านปัจจุบัน',
        too_short: '',
        invalid: '',
    },
    NewPassword: {
        name: 'รหัสผ่านใหม่',
        placeholder: 'รหัสผ่านใหม่',
        required: 'โปรดระบุรหัสผ่านใหม่',
        too_short: 'กรุณาระบุรหัสผ่านเป็นตัวอักษร (a-z, A-Z)หรือตัวเลข (0-9) อย่างน้อย 8 ตัวอักษร ',
        invalid: '',
        invalidformat: 'กรุณาระบุรหัสผ่านเป็นตัวอักษร (a-z, A-Z)หรือตัวเลข (0-9) อย่างน้อย 8 ตัวอักษร ',
        match: 'รหัสผ่านใหม่ตรงกับรหัสผ่านปัจจุบัน กรุณาระบุรหัสผ่านใหม่อีกครั้ง'
    },
    ConfirmPassword: {
        name: 'รหัสผ่านใหม่ (อีกครั้ง)',
        placeholder: 'รหัสผ่านใหม่ (อีกครั้ง)',
        required: 'โปรดระบุรหัสผ่านใหม่ (อีกครั้ง)',
        too_short: '',
        invalid: '',
        not_match: 'รหัสผ่านไม่ตรงกัน',
    },
    confirm_popup: {
        title: 'ยืนยัน?',
        msg: 'คุณยืนยันเปลี่ยนรหัสผ่านใช่หรือไม่',
        btn_ok: 'ยืนยัน',
        btn_cancel: 'ยกเลิก',
    },
    Success_popup: {
        title: 'ทำรายการสำเร็จ!',
        msg: 'รหัสผ่านของคุณได้ทำการเปลี่ยนเรียบร้อยแล้ว กรุณาใช้รหัสผ่านใหม่สำหรับเข้าสู่ระบบ',
        btn_ok: 'เข้าสู่ระบบ!',
    },

    forget: 'Forget password ?',
    save_btn: 'เปลี่ยนรหัสผ่าน',
}
